import React from 'react';
import { grey } from '@mui/material/colors';
import { Column } from 'components/shared/TableListing';

import { EventListingRow } from './types';
import { DueCell, StatusCell, AccountCell, ActionsCell, SubjectCell, EventTypeCell, PriorityCell } from './cells';

const sharedHeaderStyles: React.CSSProperties = {
  minHeight: '2.5rem',
  backgroundColor: grey[200],
};

const sharedCellStyles: React.CSSProperties = {
  padding: '0.2rem 0.5rem',
};

export const eventsListingColumns: Column<EventListingRow>[] = [
  {
    renderKey: 'due',
    header: 'DUE',
    width: '14rem',
    cellStyles: sharedCellStyles,
    headerStyles: sharedHeaderStyles,
    renderCell: ({ row }) => <DueCell due={row.due} allDay={row.allDay} />,
  },
  {
    renderKey: 'subject',
    header: 'Subject',
    cellStyles: sharedCellStyles,
    headerStyles: sharedHeaderStyles,
    renderCell: ({ row }) => <SubjectCell subject={row.subject} description={row.description} />,
  },
  {
    renderKey: 'account',
    header: 'Account',
    cellStyles: sharedCellStyles,
    headerStyles: sharedHeaderStyles,
    renderCell: ({ row }) => <AccountCell account={row.account} />,
  },
  {
    renderKey: 'type',
    header: 'Type',
    width: '10rem',
    cellStyles: sharedCellStyles,
    headerStyles: sharedHeaderStyles,
    bodyStyles: () => ({ alignItems: 'center', justifyContent: 'center', display: 'flex' }),
    renderCell: ({ row }) => <EventTypeCell type={row.type} />,
  },
  {
    renderKey: 'priority',
    header: 'Priority',
    width: '8rem',
    cellStyles: sharedCellStyles,
    headerStyles: sharedHeaderStyles,
    bodyStyles: () => ({ alignItems: 'center', justifyContent: 'center', display: 'flex' }),
    renderCell: ({ row }) => <PriorityCell priority={row.priority} />,
  },
  {
    renderKey: 'status',
    header: 'Status',
    width: '8rem',
    cellStyles: sharedCellStyles,
    headerStyles: sharedHeaderStyles,
    bodyStyles: () => ({ alignItems: 'center', justifyContent: 'center', display: 'flex' }),
    renderCell: ({ row }) => <StatusCell status={row.status} />,
  },
  {
    renderKey: 'id',
    header: 'Actions',
    width: '5rem',
    cellStyles: sharedCellStyles,
    headerStyles: sharedHeaderStyles,
    bodyStyles: () => ({ alignItems: 'center', justifyContent: 'center', display: 'flex' }),
    renderCell: ({ row }) => <ActionsCell id={row.id} />,
  },
];
